import { Pie } from 'react-chartjs-2';
import { Chart } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import classes from "./SubmmissionChart.module.css"
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import StoryLineReport from "./sources/StoryLine"
import SLCReport from "./sources/SLC"
import { ViewTypeChartEnum } from "../Shared/ViewTypeChartEnum"

Chart.register(ChartDataLabels);

const SubmmisionsChart = ({ submissions, currentAssessment }) => {

    const report = {
        SLCQuestionnaire: SLCReport,
        StorylineQuestionnaire: StoryLineReport
    }

    const texts = useSelector((state) => state.translate.texts);
    const [chartData, setChartData] = useState({
        labelsName: [],
        labelsValue: [],
        labelsColor: []
    })

    const getColorChartList = () => {
        const labelsColor = [
            '#73DED8',
            '#F881A2',
            '#815E94',
            '#F4F49E',
            '#F1D089',
            '#ED8068',
            '#F881A2',
            '#815E94',
            '#F4F49E',
            '#F1D089',
            '#ED8068',
        ]
        return labelsColor
    }

    const getRightAndWrongDataChart = () => {
        const labelesNameArray = [texts.correct, texts.inCorrect, texts.notAnswerd]
        let countArray = []
        countArray[0] = submissions.filter(s => s.success === true).length
        countArray[1] = submissions.filter(s => s.success === false).length
        countArray[2] = submissions.filter(s => s.solution == null).length
        const labelsColor = ["#73DED8", "#F68E68", "#E5E5E5"]
        const labelsWithData = labelesNameArray.filter((label, index) => countArray[index] !== 0);
        const labelsColorWithData = labelsColor.filter((label, index) => countArray[index] !== 0);
        countArray = countArray.filter((label, index) => countArray[index] !== 0);
        setChartData(prevState => ({
            ...prevState,
            labelsColor: labelsColorWithData,
            labelsName: labelsWithData,
            labelsValue: countArray
        }))
    }
    function pushToArray(key, newArray) {
        if (!newArray.includes(key))
            newArray.push(key)
        return newArray;
    }
    //todo convert solution only once count by id make object and then divide to 3 array 
    const getDetailChartData = () => {
        let labelesNameArray = [];
        //the correct one ahould be in first index 
        let corectAnswer = submissions.find(s => s.success == true)
        if (corectAnswer)
            labelesNameArray[0] = report[currentAssessment.sourceType][currentAssessment.assessmentTypeId].converSultion(corectAnswer)

        submissions && submissions.map(s => {
            let key = report[currentAssessment.sourceType][currentAssessment.assessmentTypeId].converSultion(s)
            labelesNameArray = pushToArray(key, labelesNameArray)
        })
        const labelesColors = getColorChartList()
        let countArray = []
        let i = 0
        labelesNameArray.forEach(element => {
            countArray[i] = submissions?.filter(s => report[currentAssessment.sourceType][currentAssessment.assessmentTypeId].converSultion(s) == element).length;
            i = i + 1;
        });
        // notAnswered should be gray color
        const notAnsweredIndex = labelesNameArray.findIndex(name => !name)
        labelesNameArray[notAnsweredIndex] = texts.notAnswerd

        labelesColors[notAnsweredIndex] = '#E5E5E5'
        setChartData(prevState => ({
            ...prevState,
            labelsColor: labelesColors,
            labelsName: labelesNameArray,
            labelsValue: countArray
        }))
    }

    useEffect(() => {
        const assesmentType = currentAssessment.assessmentTypeId
        switch (report[currentAssessment.sourceType][assesmentType]?.graph.dataType) {
            case ViewTypeChartEnum.DetailAnswer:
                getDetailChartData()
                break;
            case ViewTypeChartEnum.RightAndWrongAnser:
                getRightAndWrongDataChart()
                break;
        }
    }, [submissions])

    const data = {
        labels: chartData.labelsName,
        datasets: [
            {
                label: '# of Votes',
                data: chartData.labelsValue,
                backgroundColor: chartData.labelsColor,
                borderWidth: 1,
            },
        ],
    };

    const options = {
        plugins: {
            datalabels: {
                formatter: (val, context) =>
                    `${Math.round((Number(val) * 100) /
                        context.chart.data.datasets[context.datasetIndex].data.reduce(
                            (a, b) => Number(a) + Number(b),
                            0
                        ))
                    }%`,
                color: "#fff",

                font: {
                    size: "16",
                    weight: "bold"
                },
            },
            legend: {
                display: true,
                position: "bottom",
                maxWidth: "120",
                rtl: true,
                align: "start",
            }
        }
    }
    return (
        <div className={classes.ChartWarp}>
            <div className={classes.ViewAnswerLastTry}>{texts.viewAnswerLastTry}</div>
            <Pie
                data={data}
                options={options}
            />
        </div>
    )

}
export default SubmmisionsChart